import { forwardRef, type Ref, type SVGProps } from "react";
const IconEntertainmentOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M18.009 13.444c.22-.07.389-.047.487.051s.121.268.046.482l-.604 1.86 1.07 1.549c.257.378.094.705-.368.725l-1.92.08-1.212 1.567c-.205.266-.444.306-.614.136a.7.7 0 0 1-.153-.271l-.584-1.788-1.778-.574a.7.7 0 0 1-.271-.153c-.17-.17-.13-.409.136-.614l1.568-1.211.08-1.92c.016-.467.342-.63.724-.369l1.538 1.06z" />
    <path
      fillRule="evenodd"
      d="m3.615 17.985 14.37-14.37a1.84 1.84 0 0 1 2.6 0l1.893 1.892c.39.39.354 1.031.222 1.568A1.838 1.838 0 0 0 24.925 9.3c.537-.132 1.177-.169 1.568.222l1.893 1.893a1.84 1.84 0 0 1 0 2.6l-14.37 14.37a1.84 1.84 0 0 1-2.601 0l-1.893-1.893c-.39-.39-.353-1.03-.222-1.567a1.837 1.837 0 0 0-2.225-2.226c-.536.132-1.177.17-1.567-.221l-1.893-1.893a1.84 1.84 0 0 1 0-2.6m18.156-7.756a3.84 3.84 0 0 0 3.617 1.017l1.47 1.469-14.143 14.142-1.469-1.47a3.837 3.837 0 0 0-4.634-4.633l-1.469-1.47 14.142-14.14 1.47 1.469a3.84 3.84 0 0 0 1.016 3.617z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconEntertainmentOutlineSVG);
ForwardRef.displayName = "IconEntertainmentOutline";
export { ForwardRef as IconEntertainmentOutline };
